export default __webpack_public_path__ + "images/it-and-roi-hero.jpg";